import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { Collection, Feature, Map, MapBrowserEvent } from 'ol';
import GeoJSON from 'ol/format/GeoJSON';
import { Circle, Geometry, Point, Polygon } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import * as olExtent from 'ol/extent';
import { Fill, RegularShape, Stroke, Style, Text } from 'ol/style';
import { BehaviorSubject, concat, forkJoin, Observable, of, Subject } from 'rxjs';
import { map, tap, switchMap, take, concatAll } from 'rxjs/operators';
import { LayerService } from './layers/layer.service';
import { MapService } from './map.service';
import { OlLayerService } from './ol/ol-layer.service';
import { GroupLayer } from '../models/group-layer';
import LayerGroup from 'ol/layer/Group';
import { MapUtilsService } from './map-utils.service';
import OSMXML from 'ol/format/OSMXML';
import { PopupService } from './popup.service'
import { brok2geo } from 'brokjson'
import { Graticule, Layer, Vector } from 'ol/layer';
import { TT_LIB_CONFIG } from '../tt-lib.config.token';
import { AppConfig } from '../interfaces/app-config';
import { Coordinate } from 'ol/coordinate';
import { PopupData } from '../interfaces/popup-data';
import { FeatureLike } from 'ol/Feature';
import { bbox, all, tile } from 'ol/loadingstrategy.js';


@Injectable({
  providedIn: 'root'
})
export class MapindexService {


  /*
  service to show the mapindex starting from downloading level 0 geojson
  level 0 -> download geojson
  level 1 -> create geojson based on level 0 geojson
  level 2 -> draws features on the fly according the view extent
  level 3 -> draws features on the fly according the view extent 
  level 4 -> draws features on the fly according the view extent   
  the source loaders are executed in inverse order than layers
  */

  public mapindexLvl_0_List: FeatureLike[]; //Collection<any>; //Collection<Feature[]>;
  public mapindexLvl_1_List: FeatureLike[];
  public mapindexList: FeatureLike[];

  public mapindexLvl_0_ListCollection: Collection<FeatureLike>;
  public mapindexLvl_1_ListCollection: Collection<FeatureLike>;
  public mapindexLvl_2_ListCollection: Collection<FeatureLike>;


  // gridSource;
  private loadedExtent_: olExtent.Extent;
  // renderedExtent_: olExtent.Extent;

  private lvl_2_gridSource: VectorSource;
  private lvl_3_gridSource: VectorSource;
  private lvl_4_gridSource: VectorSource;

  public mapindexLayer: any;//GroupLayer;
  public mapindexLvl_0Layer: Layer;
  public mapindexLvl_1Layer: Layer;
  public mapindexLvl_2Layer: Layer;
  public mapindexLvl_3Layer: Layer;
  public mapindexLvl_4Layer: Layer;

  private readonly mapindexLvl_0_UrlString: string = './assets/JSON/grids/mapindex_lvl_0.geojson';

  private readonly defaultColor: any;
  private readonly highlightColor: any;
  private readonly colorLvl_0_: string = '#2c3c56';
  private readonly colorLvl_1_: string = '#4c75bc';
  private readonly colorLvl_2_: string = '#5f95e9';
  private readonly colorLvl_3_: string = '#5f95e9';
  private readonly colorLvl_4_: string = '#5f95e9';
  private readonly colorTextLvl_0_: string = '#2c3c56';
  public readonly colorText: string = '#0855d1';

  private readonly height_lvl_1_: number = 5000;
  private readonly width_lvl_1_: number = 8000;
  private readonly height_lvl_2_: number = 500;
  private readonly width_lvl_2_: number = 500;
  private readonly height_lvl_3_: number = 250;
  private readonly width_lvl_3_: number = 250;
  private readonly height_lvl_4_: number = 125;
  private readonly width_lvl_4_: number = 125;

  private readonly lvl_1_cells = ['1n', '1s', '5n', '5s', '2n', '2s', '6n', '6s', '3n', '3s', '7n', '7s', '4n', '4s', '8n', '8s'];
  // private readonly lvl_1_cells = ['1n', '1s', '2n', '2s', '3n', '3s', '4n', '4s', '5n', '5s', '6n', '6s', '7n', '7s', '8n', '8s'];
  private readonly lvl_2_cells = ["a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "a10",
    "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "b10",
    "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "c10",
    "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10",
    "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "e10",
    "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "f10",
    "g1", "g2", "g3", "g4", "g5", "g6", "g7", "g8", "g9", "g10",
    "h1", "h2", "h3", "h4", "h5", "h6", "h7", "h8", "h9", "h10",
    "i1", "i2", "i3", "i4", "i5", "i6", "i7", "i8", "i9", "i10",
    "j1", "j2", "j3", "j4", "j5", "j6", "j7", "j8", "j9", "j10",
    "k1", "k2", "k3", "k4", "k5", "k6", "k7", "k8", "k9", "k10",
    "l1", "l2", "l3", "l4", "l5", "l6", "l7", "l8", "l9", "l10",
    "m1", "m2", "m3", "m4", "m5", "m6", "m7", "m8", "m9", "m10",
    "n1", "n2", "n3", "n4", "n5", "n6", "n7", "n8", "n9", "n10",
    "o1", "o2", "o3", "o4", "o5", "o6", "o7", "o8", "o9", "o10",
    "p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "p9", "p10"];

  private readonly lvl_3_cells = ['w', 'y', 'x', 'z'];
  private readonly lvl_4_cells = ['w', 'y', 'x', 'z'];
  private readonly level_3_4_gridnames = [['w', 'y'], ['x', 'z']];

  private olMapClickListener_: any;
  public foundedMapindexLayer: Layer;
  public foundedMapindexLayerSource: VectorSource;
  public mapClickOnSheet$: Observable<boolean>;
  private mapindexReadySubject = new BehaviorSubject<boolean>(false);
  public mapindexReady$: Observable<any>;
  private ttLibConfig = inject<AppConfig>(TT_LIB_CONFIG);

  constructor(
    // @Inject(TT_LIB_CONFIG)
    // private ttLibConfig: AppConfig,

    private http: HttpClient,
    private mapService: MapService,
    public layerService: LayerService,
    public olLayerService: OlLayerService,
    public mapUtilsService: MapUtilsService,
    private popupService: PopupService,
  ) {
    this.mapindexReady$ = this.mapindexReadySubject.asObservable();
    this.foundedMapindexLayerSource = new VectorSource();
    this.foundedMapindexLayer = new VectorLayer({ source: this.foundedMapindexLayerSource, visible: true });
    this.foundedMapindexLayer.set('customId', 'foundedmapindexLayer');
    this.foundedMapindexLayer.setZIndex(1001);
    // //change cursor when hovering a feature in of this layer
    this.mapService.setPointerCursorOnFeatureHoverForLayerId('foundedmapindexLayer');
    //Unsubscribing in a service is pointless, since there is no chance of memory leaks.
    this.popupService.onPopupClose$.subscribe(() => { this.removeHighlightedSheet() });
    this.defaultColor = (this.ttLibConfig.map.overlays) ? this.ttLibConfig.map.overlays.defaultColor : [53, 53, 53, 1.0];
    this.highlightColor = (this.ttLibConfig.map.overlays) ? this.ttLibConfig.map.overlays.highlightColor : [253, 15, 91, 1.0];
    this.initMapClickOnSheet();
    //this.olLayerService.addOlLayerToMap(this.foundedmapindexLayer);
  }


  initMapindex(): Observable<boolean> {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }
    /*
    to minify geosjon:
    https://www.brokjson.dev/converter
    */
    //get level 0 json from brockjson
    this.http.get(this.mapindexLvl_0_UrlString, options).subscribe((res) => {
      const mapindexLvl_0_Geojson = brok2geo(res);
      this.mapindexLvl_0_List = new GeoJSON().readFeatures(mapindexLvl_0_Geojson);
      this.mapindexLvl_0_ListCollection = new Collection(this.mapindexLvl_0_List);
      //get calculated level 1 json
      this.mapindexLvl_1_List = this.getLvl_1_json();
      this.mapindexLvl_1_ListCollection = new Collection(this.mapindexLvl_1_List);//this.mapsheets25kList
      this.mapindexList = [...this.mapindexLvl_0_List, ...this.mapindexLvl_1_List]
      this.createmapindexLayer();
    });
    return this.mapindexReady$
  }


  getLvl_1_json(): Feature[] {
    const mapindexLvl_1_Geojson = new GeoJSON({
      dataProjection: 'EPSG:3812',
    });
    //for each sheet of maplvl 0 
    let lvl_1Features = [];
    this.mapindexLvl_0_ListCollection.forEach((sheet) => {
      let features = this.getGridFeatures(sheet.getGeometry().getExtent(), this.width_lvl_1_, this.height_lvl_1_, this.lvl_1_cells, sheet.get('Cell0'), '/');
      features.forEach((f) => {
        lvl_1Features.push(f);
      })
    })
    return lvl_1Features;
  }


  createmapindexLayer() {
    let map = this.mapService.getMap();

    /*  level 0 layer */
    this.mapindexLvl_0Layer = new VectorLayer({
      source: new VectorSource({
        format: new GeoJSON(),
        features: this.mapindexLvl_0_ListCollection
      }),
      // minResolution: this.mapUtilsService.getResolutionForScale(map, 300000),
      maxResolution: this.mapUtilsService.getResolutionForScale(map, Infinity),
      visible: true,
      style: this.mapindexLvl_0_Style,
    });
    this.mapindexLvl_0Layer.set('customId', 'mapindexLvl_0_Layer');

    /*  level 1 layer */
    /* to keep acces to features data, the scaldependent visibility is set in style */
    this.mapindexLvl_1Layer = new VectorLayer({
      source: new VectorSource({
        format: new GeoJSON(),
        features: this.mapindexLvl_1_ListCollection,
      }),
      // maxResolution: this.mapUtilsService.getResolutionForScale(map, 600000),
      style: this.mapindexLvl_1_Style,
    });
    this.mapindexLvl_1Layer.set('customId', 'mapindexLvl_1_Layer');

    /*  level 2 layer */
    this.mapindexLvl_2Layer = new VectorLayer({
      maxResolution: this.mapUtilsService.getResolutionForScale(map, 100000), //minZoom: 
      style: this.mapindexLvl_2_Style,
    });
    this.mapindexLvl_2Layer.set('customId', 'mapindexLvl_2_Layer');
    this.setMapindexLvl_2LayerSource();

    /*  level 3 layer */
    this.mapindexLvl_3Layer = new VectorLayer({
      maxResolution: this.mapUtilsService.getResolutionForScale(map, 10000), //minZoom: 7
      style: this.mapindexLvl_3_Style,
    });

    this.mapindexLvl_3Layer.set('customId', 'mapindexLvl_3_Layer');
    this.setMapindexLvl_3LayerSource();

    /* level 4 layer*/
    this.mapindexLvl_4Layer = new VectorLayer({
      opacity: 1.0,
      maxResolution: this.mapUtilsService.getResolutionForScale(map, 5000), //minZoom: 7
      style: this.mapindexLvl_4_Style,
    });
    this.mapindexLvl_4Layer.set('customId', 'mapindexLvl_4_Layer');
    this.setMapindexLvl_4LayerSource();

    /*  mapindex group layer */
    this.mapindexLayer = new LayerGroup({
      //layers: [this.mapindexLvl_0Layer, this.mapindexLvl_1Layer, this.mapindexLvl_2Layer, this.mapindexLvl_3Layer, this.mapindexLvl_4Layer],
      layers: [this.mapindexLvl_4Layer, this.mapindexLvl_3Layer, this.mapindexLvl_2Layer, this.mapindexLvl_1Layer, this.mapindexLvl_0Layer],
      visible: false
    });

    this.mapindexLayer.set('customId', 'mapindexLayer');
    this.mapindexLayer.setZIndex(9);
    this.addMapindexLayer();
    this.mapindexReadySubject.next(true);
  }

  addMapindexLayer(mapid?: string) {    
    if (this.mapindexLayer) {         
      this.olLayerService.addOlLayerToMap(this.mapindexLayer, mapid);
    }
  }

  removemapindexLayer(mapIds?) {
    if (this.mapindexLayer) {
      this.olLayerService.removeLayerFromMap(this.mapindexLayer, mapIds);
    }
  }

  /* source loader level 2 */
  loadLvl_2(extent) {
    // console.log('Loading 2');
    this.loadedExtent_ = extent;
    if (olExtent.isEmpty(extent)) {
      return;
    }
    let fc = this.lvl_2_gridSource.getFeaturesCollection();
    fc.clear();
    let source: VectorSource = this.mapindexLvl_1Layer.getSource() as VectorSource;
    source.forEachFeatureIntersectingExtent(extent, (feature) => {
      let features = this.getGridFeatures(feature.getGeometry().getExtent(), this.width_lvl_2_, this.height_lvl_2_, this.lvl_2_cells, feature.get('Cell_Name'), '-');
      fc.extend(features);
    })
  };
  /* source loader level 3 */
  loadLvl_3(extent) {
    // console.log('Loading 3');
    this.loadedExtent_ = extent;
    if (olExtent.isEmpty(extent)) {
      return;
    }
    let fc = this.lvl_3_gridSource.getFeaturesCollection();
    fc.clear();
    let source: VectorSource = this.mapindexLvl_2Layer.getSource() as VectorSource;
    source.forEachFeatureIntersectingExtent(extent, (feature) => {
      let features = this.getGridFeatures(feature.getGeometry().getExtent(), this.height_lvl_3_, this.height_lvl_3_, this.lvl_3_cells, feature.get('Cell_Name'), '-');
      fc.extend(features);
    })
  }
  /* source loader level 4 */
  loadLvl_4(extent) {
    // console.log('Loading 4');
    this.loadedExtent_ = extent;
    if (olExtent.isEmpty(extent)) {
      return;
    }
    let fc = this.lvl_4_gridSource.getFeaturesCollection();
    fc.clear();
    let source: VectorSource = this.mapindexLvl_3Layer.getSource() as VectorSource;
    source.forEachFeatureIntersectingExtent(extent, (feature) => {
      let features = this.getGridFeatures(feature.getGeometry().getExtent(), this.height_lvl_4_, this.height_lvl_4_, this.lvl_4_cells, feature.get('Cell_Name'), '');
      fc.extend(features);
    })
  }

  setMapindexLvl_2LayerSource() {
    // console.log('***** setMapindexLvl_2LayerSource *****')
    this.lvl_2_gridSource = new VectorSource({
      features: new Collection<Feature>(),
      // loader: this.loaderFunction.bind(this),
      loader: (extent, resolution, projection) => {
        if (resolution > 2) {
          this.loadLvl_2(extent);
        }
      },
      strategy: this.strategyFunction.bind(this),
      overlaps: false,
      useSpatialIndex: false,
      wrapX: false
    });
    this.mapindexLvl_2Layer.setSource(this.lvl_2_gridSource);
  }

  setMapindexLvl_3LayerSource() {
    this.lvl_3_gridSource = new VectorSource({
      features: new Collection<Feature>(),
      // loader: this.loaderFunction.bind(this),
      loader: (extent, resolution, projection) => {
        if (resolution > 0.7) {
          // this.combinedSubject.next({ lvl: 3, extent: extent }); 
          this.loadLvl_2(extent);
          this.loadLvl_3(extent);
        }
      },
      strategy: this.strategyFunction.bind(this),
      overlaps: false,
      useSpatialIndex: false,
      wrapX: false
    });
    this.mapindexLvl_3Layer.setSource(this.lvl_3_gridSource);
  }

  setMapindexLvl_4LayerSource() {
    this.lvl_4_gridSource = new VectorSource({
      features: new Collection<Feature>(),
      loader: (extent, resolution, projection) => {
        this.loadLvl_2(extent);
        this.loadLvl_3(extent);
        this.loadLvl_4(extent);
      },
      strategy: this.strategyFunction.bind(this),
      overlaps: false,
      useSpatialIndex: false,
      wrapX: false
    });
    this.mapindexLvl_4Layer.setSource(this.lvl_4_gridSource);
  }

  strategyFunction(extent, resolution) {
    let realExtent = extent.slice();
    if (this.loadedExtent_) {
      if (this.approximatelyEquals(this.loadedExtent_, realExtent, resolution)) {
        // make sure result is exactly equal to previous extent
        realExtent = this.loadedExtent_.slice();
      } else {
        // we should not keep track of loaded extents
        this.lvl_2_gridSource.removeLoadedExtent(this.loadedExtent_);
        this.lvl_3_gridSource.removeLoadedExtent(this.loadedExtent_);
        this.lvl_4_gridSource.removeLoadedExtent(this.loadedExtent_);
      }
    }
    return [realExtent];
  }

  approximatelyEquals(extent1, extent2, tolerance) {
    return (
      Math.abs(extent1[0] - extent2[0]) < tolerance &&
      Math.abs(extent1[2] - extent2[2]) < tolerance &&
      Math.abs(extent1[1] - extent2[1]) < tolerance &&
      Math.abs(extent1[3] - extent2[3]) < tolerance
    );
  }

  getCellNameFromFeatureAndCoordinate(feature, coordinate) {
    let cellName;
    let firstCoordinate = feature.getGeometry().getFirstCoordinate();
    //avoid errors when common lines overlapping of feature extent
    if (coordinate[0] < firstCoordinate[0] || firstCoordinate[1] < coordinate[1]) {
      return false;
    }
    let lvl_2_xIndex = Math.floor((coordinate[0] - feature.getGeometry().getFirstCoordinate()[0]) / this.width_lvl_2_);
    let lvl_2_yIndex = Math.ceil((feature.getGeometry().getFirstCoordinate()[1] - coordinate[1]) / this.height_lvl_2_);
    let lvl_3_xIndex = Math.floor((coordinate[0] - firstCoordinate[0]) / this.width_lvl_3_) % 2;
    let lvl_3_yIndex = Math.floor((firstCoordinate[1] - coordinate[1]) / this.height_lvl_3_) % 2;
    let lvl_4_xIndex = Math.floor((coordinate[0] - firstCoordinate[0]) / this.width_lvl_4_) % 2;
    let lvl_4_yIndex = Math.floor((firstCoordinate[1] - coordinate[1]) / this.height_lvl_4_) % 2;
    let name_lvl_3 = this.level_3_4_gridnames[lvl_3_xIndex][lvl_3_yIndex];
    let name_lvl_4 = this.level_3_4_gridnames[lvl_4_xIndex][lvl_4_yIndex];
    cellName = (feature.get('Cell_Name') + '-' + String.fromCharCode(97 + lvl_2_xIndex) + lvl_2_yIndex + '-' + name_lvl_3 + '' + name_lvl_4);
    return cellName;
  }


  //from upperleft column 
  getGridFeatures(extent: olExtent.Extent, width: number, height: number, cellNames?: string[], parentCellName?: string, delimiter?: string): Feature[] {
    const bbox = extent;
    const features = [];
    const west = bbox[0];
    const south = bbox[1];
    const east = bbox[2];
    const north = bbox[3];
    const bboxWidth = east - west;
    const cellWidth = width;
    const bboxHeight = north - south;
    const cellHeight = height;
    const columns = Math.floor(Math.abs(bboxWidth) / cellWidth);
    const rows = Math.floor(Math.abs(bboxHeight) / cellHeight);
    // if the grid does not fill the bbox perfectly, center it.
    const deltaX = (bboxWidth - columns * cellWidth) / 2;
    const deltaY = (bboxHeight - rows * cellHeight) / 2;
    // iterate over columns & rows
    let currentX = west + deltaX;
    for (let column = 0; column < columns; column++) {
      let currentY = north - deltaY;
      for (let row = 0; row < rows; row++) {
        const cellPolyFeature = new Feature(
          {
            geometry: new Polygon(
              [
                [
                  [currentX, currentY],
                  [currentX, currentY - cellHeight],
                  [currentX + cellWidth, currentY - cellHeight],
                  [currentX + cellWidth, currentY],
                  [currentX, currentY],
                ],
              ]
            ),
            labelPoint: new Point([(currentX + cellWidth) / 2, (currentY + cellHeight) / 2],),
            name: cellNames[features.length]?.toString(),
            Cell_Name: (parentCellName) ? parentCellName + delimiter + cellNames[features.length]?.toString() : '',
          },
        )
        cellPolyFeature.setId(Math.random());
        features.push(cellPolyFeature);
        currentY -= cellHeight;
      }
      currentX += cellWidth;
    }
    // let features: any = results;
    return features;
  }

  searchFeatureForLvl_0_and_1(sheetIdToFind) {
    let feature;
    this.mapindexList.forEach((item) => {
      // let sheetId: string = item.get('SHEETID').toLowerCase();
      let sheetId: string = item.get('Cell_Name').toLowerCase();
      sheetId = this._removeLeadingZerosToSheetsIds(sheetId);
      if (sheetId == sheetIdToFind) {
        feature = item;
      }
    })
    return feature;
  }

  // foundedLvl_1_feature
  searchMapindex(value: string) {
    let feature = undefined;
    let sheetIdToFind: string = value.toLowerCase().trim();
    sheetIdToFind = this._removeLeadingZerosToSheetsIds(sheetIdToFind);
    if (sheetIdToFind.includes('-')) {
      let lvl_1FeatureId = sheetIdToFind.substring(0, sheetIdToFind.indexOf('-'));
      let lvl_1plusFeatureId = sheetIdToFind.substring(sheetIdToFind.indexOf('-') + 1);
      let lvl_1_2_feature = this.searchFeatureForLvl_0_and_1(lvl_1FeatureId);
      if (lvl_1_2_feature) {
        //sjek level2
        if (lvl_1plusFeatureId.length == 2 || (lvl_1plusFeatureId.length == 3)) {
          if (this.lvl_2_cells.includes(lvl_1plusFeatureId)) {
            let mapindexId_lvl_2 = lvl_1plusFeatureId;
            feature = this.getFeatureFromMapindexId(lvl_1_2_feature, mapindexId_lvl_2);
          }
        }
        if (lvl_1plusFeatureId.includes('-')) {
          let mapindexId_lvl_2 = lvl_1plusFeatureId.substring(0, lvl_1plusFeatureId.indexOf('-'));
          if (this.lvl_2_cells.includes(mapindexId_lvl_2)) {
            mapindexId_lvl_2 = lvl_1plusFeatureId;
          }
          let mapindexId_lvl_2plus = lvl_1plusFeatureId.substring(lvl_1plusFeatureId.indexOf('-') + 1)
          if (mapindexId_lvl_2plus.length <= 2) {
            if (mapindexId_lvl_2plus.length == 1) {
              let mapindexId_lvl_3 = mapindexId_lvl_2plus.substring(0, 1)
              if (this.lvl_3_cells.includes(mapindexId_lvl_3)) {
                feature = this.getFeatureFromMapindexId(lvl_1_2_feature, mapindexId_lvl_2, mapindexId_lvl_3);
              }
            }
            else if (mapindexId_lvl_2plus.length == 2) {
              let mapindexId_lvl_3 = mapindexId_lvl_2plus.substring(0, 1)
              if (this.lvl_3_cells.includes(mapindexId_lvl_3)) {
                let mapindexId_lvl_4 = mapindexId_lvl_2plus.substring(1);
                if (this.lvl_4_cells.includes(mapindexId_lvl_4)) {
                  feature = this.getFeatureFromMapindexId(lvl_1_2_feature, mapindexId_lvl_2, mapindexId_lvl_3, mapindexId_lvl_4);
                }
              }
            }
          }
        }
      }
    } else {
      //try for level 0 and 1
      feature = this.searchFeatureForLvl_0_and_1(sheetIdToFind);
    }
    if (feature) {
      return feature;
    }
  }


  getFeatureFromMapindexId(feature, mapindexId_lvl_2, mapindexId_lvl_3?, mapindexId_lvl_4?) {
    let cell_name = feature.get('Cell_Name');
    // define upper left coordinate
    let firstCoordinate = feature.getGeometry().getFirstCoordinate();
    //lvl 2 values
    let col = mapindexId_lvl_2.substring(0, 1).charCodeAt(0) - 97;
    let row = parseInt(mapindexId_lvl_2.substring(1, 3)) - 1;
    let cellHeight = this.height_lvl_2_;
    let cellWidth = this.width_lvl_2_;
    cell_name += '-'
    cell_name += mapindexId_lvl_2;
    let currentY = firstCoordinate[1] - this.width_lvl_2_ * row;
    let currentX = this.height_lvl_2_ * col + firstCoordinate[0];
    //lvl 3 values
    if (mapindexId_lvl_3) {
      cellHeight = this.height_lvl_3_;
      cellWidth = this.width_lvl_3_;
      cell_name += '-'
      cell_name += mapindexId_lvl_3;
      if (this.lvl_3_cells.indexOf(mapindexId_lvl_3) > 1) {
        currentX += this.height_lvl_3_
      };
      if (this.lvl_3_cells.indexOf(mapindexId_lvl_3) == 1 || this.lvl_3_cells.indexOf(mapindexId_lvl_3) == 3) {
        currentY -= this.width_lvl_3_;
      };
    }
    //lvl 4 values
    if (mapindexId_lvl_4) {
      cellHeight = this.height_lvl_4_;
      cellWidth = this.width_lvl_4_;
      cell_name += mapindexId_lvl_4;
      if (this.lvl_4_cells.indexOf(mapindexId_lvl_4) > 1) {
        currentX += this.height_lvl_4_
      };
      if (this.lvl_4_cells.indexOf(mapindexId_lvl_4) == 1 || this.lvl_3_cells.indexOf(mapindexId_lvl_4) == 3) {
        currentY -= this.width_lvl_4_;
      };
    }
    const cellPolyFeature = new Feature(
      {
        geometry: new Polygon(
          [
            [
              [currentX, currentY],
              [currentX, currentY - cellHeight],
              [currentX + cellWidth, currentY - cellHeight],
              [currentX + cellWidth, currentY],
              [currentX, currentY],
            ],
          ]
          // ,
          // options.properties
        ),
        labelPoint: new Point([(currentX + cellWidth) / 2, (currentY + cellHeight) / 2],),
        Cell_Name: cell_name,
      },
    )
    return cellPolyFeature;
  }

  private _removeLeadingZerosToSheetsIds(sheetId: string): string {
    let splittedSheetNames: string[] = sheetId.split("/")
    splittedSheetNames = splittedSheetNames.map((sheetPart) => sheetPart.replace(/^0+/, ""))
    return splittedSheetNames.join("/");
  }

  /*

  map interactions

  */

  initMapClickOnSheet() {
    let mappi: any = this.mapService.getMap();
    //returns sheet feature or null on mapclick
    this.mapClickOnSheet$ =
      new Observable((observer) => {
        this.olMapClickListener_ = mappi.on('click', (event: Event) => {
          observer.next(event);
        })
      }
      ).pipe(
        map((event: MapBrowserEvent<any>) => {
          var pixelClick = (event.type === 'touchstart') ? mappi.getEventPixel(event) : event.pixel;
          return (
            of(mappi.forEachFeatureAtPixel(pixelClick, (feature) => feature,
              { layerFilter: (layer) => layer.get('customId') === 'foundedmapindexLayer' }
            ) || null)
          )
        }),
        switchMap(sheet => { return sheet })
      );
  }
  add(sheet: Feature) {
    if (!this.olLayerService.getLayerById("foundedmapindexLayer")) {
      this.olLayerService.addOlLayerToMap(this.foundedMapindexLayer);
      this.mapClickOnSheet$.subscribe((sheet) => (sheet) ? this.handleSheetClick(sheet) : this.outsideSheetClick());
    }
    this.highlight(sheet);
    this.foundedMapindexLayerSource.addFeature(sheet);
  }

  remove(feature: Feature) {
    this.foundedMapindexLayerSource.removeFeature(feature);
  }

  hasThisSheet(sheet: Feature): boolean {
    return this.foundedMapindexLayerSource.hasFeature(sheet);
  }

  handleSheetClick(sheet: any) {
    if (sheet.get('highlight')) {
      this.unHighlight(sheet)
    } else {
      this.displaySheetPopup(sheet)
      this.highlight(sheet);
    }
  }

  outsideSheetClick() {
    this.unHighlightSheets();
  }

  setSheetStyle(sheet: Feature<Geometry>) {
    sheet.setStyle(this.sheetHighlightStyle);
    sheet.set('highlight', true);
  }

  removeHighlightedSheet() {
    this.foundedMapindexLayerSource.getFeatures().forEach(sheet => {
      if (sheet.get('highlight')) {
        this.remove(sheet);
      }
    });
  }

  private highlight(sheet: Feature) {
    sheet.setStyle(this.sheetHighlightStyle);
    sheet.set('highlight', true);
  }

  private unHighlight(sheet: Feature) {
    sheet.setStyle(this.sheetStyle);
    sheet.set('highlight', false);
  }

  private unHighlightSheets() {
    this.foundedMapindexLayerSource.getFeatures().forEach(sheet => {
      if (sheet.get('highlight')) {
        this.unHighlight(sheet);
      }
    });
  }

  public displaySheetPopup(sheet: Feature) {
    let sheetCenter: Coordinate = olExtent.getCenter(sheet.getGeometry().getExtent());
    let popupProperties: PopupData =
    {
      coordinates: sheetCenter,
      type: 'geocoding',
      // title: 'geocoding.sheet' + sheet.get('sheetType') + '-title', 
      title: 'geocoding.sheet-title',
      // content: sheet.get('SHEETID') + ' ' + sheet.get('NAME'),
      content: sheet.get('Cell_Name'),
      zoomToFeatureLink: false,
      //zoomlevel: zoomlevel
    }
    this.popupService.add(popupProperties);
  }
  /*
  
  styles
  
  */
  public mapindexStyle = (feature) => {
    return new Style(
      {
        stroke: new Stroke({
          // color: 'rgba(40,187,221,1.0',
          color: 'rgba(255,109,40,1.0)',
          width: 0.5,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          color: 'rgba(40,195,220,0.0)',
        }),
        text: new Text({
          text: feature.get('name'),
          font: '400 16px Source Sans Pro',
          fill: new Fill({
            // color: 'rgba(0,255,0,0.1)',
            color: 'rgba(255,109,40,1.0)',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 3,
          }),
        }),
      })
  };

  public roadsStyle = new Style({
    stroke: new Stroke({
      // color: 'rgba(255, 103, 11, 1.0)',
      color: 'rgba(75, 183, 11, 1.0)',
      width: 1,
      lineCap: 'butt',
      lineJoin: 'miter'
    }),
    fill: new Fill({
      color: 'rgba(40,195,220,0.0)',
    }),
    text: new Text({

      font: '13px "Source Sans Pro"',
      text: 'test zone for snap to road (not for this release)',
      textAlign: 'center',
      placement: 'line',
      offsetY: -15,
      fill: new Fill({
        color: 'rgba(51, 133, 0, 1.0)',
      }),
      stroke: new Stroke({
        color: [255, 255, 255, 1.0],
        width: 4
      })

    })
    // text: new Text({


    //   font: '13px "Source Sans Pro"',
    //   text: 'test zone for snap to road (not for this release)',
    //   textAlign: 'left',
    //   placement: 'line',
    //   offsetY: -15,
    //   fill: new Fill({
    //     color: 'rgba(51, 133, 0, 1.0)',
    //   }),
    //   stroke: new Stroke({
    //     color: [255, 255, 255, 1.0],
    //     width: 4
    //   })

    // })
  });

  public mapSheetsDefaultStyle = (feature, resolution) => {
    return new Style({
      stroke: new Stroke({
        // color: 'rgba(7, 55, 73,1.0)',
        // color: (resolution > 130) ? 'rgba(7, 55, 73, 0.8)' : (resolution > 66) ? 'rgba(7, 55, 73, 0.4)' : (resolution > 26) ? 'rgba(7, 55, 73,0.3)' : 'rgba(7, 55, 73,0.2)',
        color: 'rgba(109,109,109,1.0)',
        // width: (resolution > 26) ? (Math.round(280 * 1 / resolution)) : (resolution > 13) ? 11 : 17,
        width: 1,
        lineCap: 'butt',
        lineJoin: 'miter'
      }),
      fill: new Fill({
        color: 'rgba(255,229,0,0.1)',
      }),
      text: new Text({
        font: '900 18px Source Sans Pro',
        fill: new Fill({
          // color: 'rgba(0,255,0,0.1)',
          color: 'rgba(255,109,40,1.0)',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3,
        }),
      }),
    });

  }
  public mapindexLvl_4_Style = (feature, resolution) => {
    return [
      // this.shadowStyle,
      new Style({
        stroke: new Stroke({
          // color: (resolution > 130) ? 'rgba(7, 55, 73, 0.8)' : (resolution > 66) ? 'rgba(7, 55, 73, 0.4)' : (resolution > 26) ? 'rgba(7, 55, 73,0.3)' : 'rgba(7, 55, 73,0.2)',
          color: this.colorLvl_4_,
          //color: 'rgb(124, 53,201)',
          width:
            (resolution > 0.4) ?
              0.5 :
              1,
          // width: 0.6,
          //width: 1.2,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          // color: 'rgba(255,229,0,0.1)',
          color: 'rgba(255,255,255,0.0)',
        }),
        text: new Text({
          font:
            (resolution > 0.4) ?
              '400 18px Source Sans Pro' :
              '400 32px Source Sans Pro',
          fill: new Fill({
            // color: 'rgba(0,255,0,0.1)',
            color: this.colorText,
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 3,
          }),
          text:
            // (resolution < 0.5) ?
            // feature.get('Cell_Name') :
            feature.get('name')
        }),
        zIndex: 15
      })];

  }

  public mapindexLvl_3_Style = (feature, resolution) => {
    return [
      // this.shadowStyle,
      new Style({
        stroke: new Stroke({
          // color: (resolution > 130) ? 'rgba(7, 55, 73, 0.8)' : (resolution > 66) ? 'rgba(7, 55, 73, 0.4)' : (resolution > 26) ? 'rgba(7, 55, 73,0.3)' : 'rgba(7, 55, 73,0.2)',
          color: this.colorLvl_3_,
          //color: '#ff6600',
          width:
            (resolution > 0.7) ?
              0.5 :
              (resolution > 0.4) ?
                3 :
                4,
          // width: 0.6,
          //width: 1.2,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          // color: 'rgba(255,229,0,0.1)',
          color: 'rgba(255,255,255,0.0)',
        }),
        text: new Text({
          font: (resolution > 0.7) ?
            '400 18px Source Sans Pro' :
            (resolution > 0.4) ?
              '400 32px Source Sans Pro' :
              '400 48px Source Sans Pro',
          fill: new Fill({
            // color: 'rgba(0,255,0,0.1)',
            color: this.colorText,
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 3,
          }),
          text:
            // (resolution < 1) ?
            //   feature.get('Cell_Name') :
            feature.get('name')
        }),
        zIndex: 16
      })];

  }

  public mapindexLvl_2_Style = (feature, resolution) => {
    return [
      //  this.shadowStyle,
      new Style({
        stroke: new Stroke({
          // color: (resolution > 130) ? 'rgba(7, 55, 73, 0.8)' : (resolution > 66) ? 'rgba(7, 55, 73, 0.4)' : (resolution > 26) ? 'rgba(7, 55, 73,0.3)' : 'rgba(7, 55, 73,0.2)',
          color: this.colorLvl_2_,
          width:
            (resolution > 7) ?
              0.5 :
              (resolution > 3) ?
                0.7 :
                (resolution > 1.5) ?
                  1 :
                  (resolution > 0.7) ?
                    3 :
                    5,
          //width: 1.2,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          // color: 'rgba(255,229,0,0.1)',
          color: 'rgba(255,255,255,0.0)',
        }),

        text:
          (resolution < 7) ? new Text({
            font:
              (resolution > 3) ?
                '400 12px Source Sans Pro' :
                (resolution > 1.5) ?
                  '400 14px Source Sans Pro' :
                  (resolution > 0.7) ?
                    '400 18px Source Sans Pro' :
                    (resolution > 0.4) ?
                      '400 24px Source Sans Pro' :
                      '400 32px Source Sans Pro',
            fill: new Fill({
              // color: 'rgba(0,255,0,0.1)',
              color: this.colorText,
            }),
            stroke: new Stroke({
              color: '#fff',
              width: (resolution < 1) ? 6 : 3
            }),
            //text: feature.get('SHEETID')
            text:
              (resolution < 2) ?
                feature.get('Cell_Name') :
                feature.get('name')
          }) : null
        ,
        zIndex: 17
      })];
  }

  public mapindexLvl_1_Style = (feature, resolution) => {
    return [
      // this.shadowStyle,
      new Style({
        stroke: (resolution < 150) ? new Stroke({
          color: this.colorLvl_1_,
          width:
            (resolution > 75) ?
              0.3 :
              (resolution > 35) ?
                0.7 :
                (resolution > 15) ?
                  1.3 :
                  (resolution > 7) ?
                    2 :
                    (resolution > 3) ?
                      3 :
                      (resolution > 1.5) ?
                        5 :
                        7,
          lineCap: 'butt',
          lineJoin: 'miter'
        }) : null,
        fill: new Fill({
          color: 'rgba(255,255,255,0.0)',
        }),
        text:
          (resolution < 75) ?
            new Text({
              font:
                (resolution > 35) ?
                  '600 14px Source Sans Pro' :
                  (resolution > 15) ?
                    '600 18px Source Sans Pro' :
                    (resolution > 7) ?
                      '600 21px Source Sans Pro' :
                      '600 29px Source Sans Pro',
              fill: new Fill({
                color: this.colorText,
              }),
              stroke: new Stroke({
                color: 'rgba(255,255,255,1.0',
                width: (resolution < 7) ? 6 : 2,
              }),
              // text: feature.get('SHEETID')
              // text: feature.get('name')
              text:
                (resolution < 26) ?
                  feature.get('Cell_Name') :
                  feature.get('name')
            })
            : null,
        zIndex: 18
      })];
  }

  public mapindexLvl_0_Style = (feature, resolution) => {
    return [
      // this.shadowStyle,
      new Style({
        stroke: new Stroke({
          // color: (resolution > 130) ? 'rgba(7, 55, 73, 0.8)' : (resolution > 66) ? 'rgba(7, 55, 73, 0.4)' : (resolution > 26) ? 'rgba(7, 55, 73,0.3)' : 'rgba(7, 55, 73,0.2)',
          color: this.colorLvl_0_,
          //  width: 
          // (resolution > 26) ? 
          // (Math.round(280 * 1 / resolution)) : 
          // (resolution > 13) ? 
          // 11 : 
          // 17,
          width:
            (resolution > 1000) ?
              1.2 :
              (resolution > 300) ?
                1.5 :
                (resolution > 150) ?
                  2 :
                  (resolution > 75) ?
                    2.5 :
                    (resolution > 35) ?
                      3 :
                      (resolution > 15) ?
                        4 :
                        5,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          color: 'rgba(255,255,255,0.0)',
        }),
        text: new Text({
          font:
            (resolution > 1000) ?
              '600 9px Source Sans Pro' :
              (resolution > 300) ?
                '600 12px Source Sans Pro' :
                (resolution > 150) ?
                  '600 15px Source Sans Pro' :
                  (resolution > 75) ?
                    '600 17px Source Sans Pro' :
                    (resolution > 35) ?
                      '600 21px Source Sans Pro' :
                      '600 27px Source Sans Pro',
          fill: new Fill({
            color: this.colorTextLvl_0_,
          }),
          stroke: new Stroke({
            color: '#fff',
            width:
              (resolution > 1000) ?
                2 :
                (resolution > 300) ?
                  3 :
                  (resolution > 150) ?
                    4 :
                    (resolution > 75) ?
                      6 :
                      8,
          }),
          // text: (resolution > 500) ? null : feature.get('SHEETID')
          text: feature.get('Cell_Name'),
          // text: feature.get('name')

        }),
        zIndex: 19
      })
    ];
  }


  public sheetStyle =
    (feature, resolution) => {
      return [
        new Style({
          stroke: new Stroke({
            color: 'rgba(44,60,86,1.0)',
            width: 4,
            lineCap: 'butt',
            lineJoin: 'miter'
          }),
          fill: new Fill({
            color: 'rgba(234,180,0,0.1)',
          }),
          text: new Text({
            font: '400 17px Source Sans Pro',
            fill: new Fill({
              color: 'rgba(255,255,255,1.0)',
            }),
            textBaseline: 'middle',
            placement: 'point',
            overflow: false,
            backgroundFill: new Fill({
              color: 'rgba(44,60,86,1.0)',
            }),
          }),
          zIndex: 53
        })
      ];
    }

  public shadowStyle =
    new Style({
      stroke: new Stroke({
        color: 'rgba(255,255,255,0.4)',
        width: 4,
        //width: (resolution > 26) ? 1.2 : (resolution > 13) ? 27 : (resolution > 6) ? 30 : 2.4,
        lineCap: 'butt',
        lineJoin: 'miter'
      }),
      zIndex: 0
    });

  public sheetHighlightStyle = (feature, resolution) => {
    return [
      new Style({
        stroke: new Stroke({
          color: 'rgba(234, 89, 0,1.0)',
          width: 5,
          lineCap: 'butt',
          lineJoin: 'miter'
        }),
        fill: new Fill({
          color: 'rgba(234,180,0,0.1)',
        }),
        zIndex: 101
      }),
      //cross in center of sheet
      new Style({
        geometry: new Point(olExtent.getCenter(feature.getGeometry().getExtent())),
        image: new RegularShape({
          //fill: new Fill({ color: 'red' }),
          stroke: new Stroke({
            color: 'rgba(234, 89, 0,1.0)',
            width: 2
          }),
          points: 4,
          radius: 10,
          radius2: 0,
          angle: 0,
        })
      })
    ];
  }

}